let es = {
    message: {
        noEvents: "Este mes no tiene ningún evento en el calendario.",
        assignCounselor: "Se le asignará a la primera consejera, si no acepta en un plazo de 2h,",
        assignCounselor2: " se le asignará a la siguiente y así hasta la 3ª consejera",
        assignCounselor3: "Se le asignará automáticamente la consejera seleccionada.",
        selectedCounselorPlural: "Consejeras seleccionadas:",
        selectedCounselor: "Consejera seleccionada",
        assignTRL: "Asignar TRL",
        save: "Guardar",
        create: "Crear",
        edit: "Editar",
        new: "Nuevo",
        remove: "Eliminar",
        editCompany: "Editar empresa",
        createCompany: "Nueva empresa",
        tlrName: "Nombre del TRL*",
        servicesR: "Servicios*",
        taskR: "Tarea*",
        nameEnR: "Nombre En*",
        nameEsR: "Nombre Es*",
        nameR: "Nombre*",
        descriptionEsR: "Descripción ES*",
        descriptionEnR: "Descripción EN*",
        categoryR: "Categoria*",
        done: "Hecho",
        cancel: "Cancelar",
        general: "General",
        services: "Servicios",
        removeUser: "Eliminar usuario",
        personalData: "DATOS PERSONALES",
        personalDataL: "Datos personales",
        contServices: "SERVICIOS CONTRATADOS",
        relocateCity: "Ciudad de realojo",
        personalEmail: "Email personal",
        profesionalEmailR: "Email profesional*",
        lastnameR: "Apellidos*",
        visibleLegal: "Visible para legal",
        packages: "Paquetes",
        independentServices: "Servicios independientes",
        deselectAll: "Deseleccionar todos los servicios",
        yes: "Si",
        no: "No",
        download: "Descargar",
        history: "Historial de",
        created: "creado",
        modified: "modificado",
        app: {
            home: 'Home',
            usuarios: 'Usuarios',
            viviendas: 'Viviendas',
            empresas: 'Empresas',
            services: 'Servicios',
            documentacion: 'Documentación',
            puedesubir: 'Puede subir su foto para que nos pongamos cara',
            puedeeditar: 'Puede editar su foto',
            cambiarcontrasena: 'Cambiar contraseña',
            salir: 'Salir',
            politicadeprivacidad: 'Política de privacidad'
        },
        panelficha: {
            removeUser: "Eliminar usuario",
            seeHistory: "Ver historial",
            editServices: "Editar servicios",
            servicesList: 'Listado de servicios',
            assignCounselor: "Asignar consejera",
            showLegal: "Mostrar a legal",
            mobile: "Móvil",
            work: 'Trabajo',
            personal: "Personal",
            contact: "Contacto",
            company: "Empresa",
            close: "Cerrar",
            copyLink: "Copiar link a encuesta en portapapeles",
            copyActivationLink: "Copiar link de activación en portapapeles",
            ended: "FINALIZADO",
            backTousers: "Volver a Usuarios",
            selectHomes: "Seleccionar viviendas",
            otherActions: "Otras acciones"
        },
        panelfiltrosempresas: {
            filter: 'Filtrar',
            find: "Buscar una empresa",
            filterCompanies: "Filtrar empresas "
        },
        panelfiltrosviviendas: {
            disponibilidad: 'Disponibilidad',
            disponible: 'Disponible',
            noDisponible: 'No disponible',
            eraseFilters: 'Borrar filtros',
            zone: 'Zona',
            noResults: 'No hay resultados',
            price: 'Precio',
            squareMeters: 'Metros cuadrados',
            houseType: 'Tipo de vivienda',
            piso: 'Piso',
            casa: 'Casa o chalet',
            roomsNumber: 'Nº habitaciones',
            bathsNumber: 'Nº baños',
            equipment: 'Equipamiento',
            state: 'Estado',
            style: 'Estilo',
            characteristics: 'Características',
            filter: 'Filtrar viviendas',
            select: 'Seleccione',
            filterAction: 'Filtrar',
            ac: 'AC',
            heating: 'Calefacción',
            garden: 'Jardín',
            terrace: 'Terraza',
            pool: 'Piscina',
            storageRoom: 'Trastero',
            childZones:  'Zonas infantiles',
            serviceRoom: 'Habitación de servicio',
            sunny: 'Soleado',
            metro: 'Metro/FGC',
            petsFriendly: 'Admite mascotas',
            garage: 'Garaje',
            styleClassic: 'Clásico',
            styleModern: 'Moderno',
            styleOther: 'Otro',
            findAddress: 'Buscar por dirección o barrio',
            noLimit: 'sin límite',
            from: 'De',
            to: 'a',
            backTo: 'Volver a la ficha de',
        },
        panelfiltrospersonas: {
            buscar: 'Buscar',
            tipo: 'Tipo',
            todos: 'Todos',
            trls: 'TRLs',
            rrhh: 'RRHH',
            consejeras: 'Consejeras',
            admin: 'Admin',
            estado: 'Estado',
            activos: 'Activos',
            finalizados: 'Finalizados',
            downloadUsers: "Descargar usuarios",
            onlySafari: "Función solo disponible en el navegador Safari",
            filterUsers: "Filtrar usuarios"
        },
        panelfiltrostareas: {
            buscartrl: 'Buscar TRL',
            consejeras: 'Consejeras',
            trls: 'TRLs',
            todas: 'Todas',
            notienes: 'No tienes ningún TRL asociado',
            filter: "Filtrar",
            filterUsers: "Filtrar usuarios"
        },
        login: {
            area: 'Área privada',
            somos: 'Somos una empresa formada por profesionales que llevan dedicados más de 20 años a los traslados internacionales, con una amplia experiencia en todos los sectores que constituyen un servicio de relocation.',
            email: 'Email',
            contraseña: 'Contraseña',
            acceder: 'Acceder',
            hasolvidado: '¿Has olvidado tu contraseña?',
            recuperar: 'Recuperar contraseña',
            volverallogin: 'Volver al login',
            almenos4: 'Al menos 4 caracteres',
            min4: 'Mínimo 4 caracteres',
            almenos8: 'Al menos 8 caracteres',
            hard: 'Debe contener al menos 8 caracteres de entre ellos una mayúscula, una minúscula, un número y un caracter especial',
            nosegurahard: 'Contraseña no segura, recuerda que debe contener al menos 8 caracteres de entre ellos una mayúscula, una minúscula, un número y un caracter especial',
            mailnovalido: 'Formato de email no válido',
            usuariocontraseñaincorrecto: 'El email / contraseña introducidos no son correctos',
            escribeLaDireccionDeEmail: 'Escribe la dirección de email asociada a tu cuenta y te enviaremos las indicaciones para restablecer tu contraseña. Es posible que acaben en tu carpeta de correo no deseado o spam, por favor revísala también.',
            setehaenviadounemail: 'Se te ha enviado un email, sigue las instrucciones para recuperar tu contraseña',
            tuContrasenaSeHaRestaurado: 'Tu contraseña se ha cambiado correctamente',
            demasiadosintentos: 'Has realizado demasiados intentos erróneos, espera 15 minutos para volver a intentarlo',
            creacontraseña: 'Crea tu contraseña',
            creanuevacontraseña: 'Crea una nueva contraseña',
            tunombre: 'Tu nombre de usuario:',
            restablecer: 'Restablecer contraseña',
            usuarioinactivo: "Usuario todavía inactivo, pincha en el link enviado por email para activarlo"
        },
        documentacion: {
            documentacion: 'Documentación',
            subirarchivo: 'Subir un archivo',
            tusdocumentos: 'Tus documentos',
            todaviano: 'Todavía no has subido ningún documento',
            documentossubidos: 'Documentos subidos por Steps Relocation',
            recuerdaquelosnombres: 'Recuerda que los nombres de los archivos no deben contener tildes ni caracteres de puntuación o símbolos.<br>Tamaño de archivo máximo 16Mb.',
            archivolimite: 'No se puede subir el archivo porque supera el límite de tamaño de 16megas.',
            archivocaracteres: 'No se puede subir el archivo porque contiene caracteres especiales que no están admitidos.'
        },
        empresas: {
            create: "Crear empresa",
            sort: 'Ordenar',
            companies: 'Empresas',
            recent: 'Recientes',
            finished: 'finalizados',
            actives: 'activos',
            companyData: 'Datos empresa',
            companyEdited: 'La empresa se ha editado correctamente.',
            companyCreated: 'La empresa se ha creado correctamente',
            noResults: 'No hay resultados',
            address: 'Dirección de las oficinas',
            billAddress: 'Dirección de facturación ',
            name: 'Nombre',
            editCompany: "Editar empresa",
            newCompany: "Nueva empresa",
            nameaz: "Nombre a-z",
        },
        usuarios: {
            usuarios: 'Usuarios',
            ordenar: 'Ordenar',
            recientes: 'Recientes',
            apellidosaz: 'Apellidos a-z',
            apellidosza: 'Apellidos z-a',
            filtrarpor: 'Filtrar por',
            consejeras: 'Consejeras',
            nohay: 'No hay resultados',
            empresas: 'Empresas',
            nuevousuario: 'Nuevo usuario',
            trl: 'TRL',
            rrhh: 'RRHH',
            noencontrado: 'No se han encontrado usuarios',
            actives: 'activos',
            inactives: 'inactivos',
            seeAll: 'Ver todos',
            filterBy: "Filtrar por"
        },
        home: {
            calendario: 'Calendario',
            listado: 'Listado',
            addTask: 'Añadir tarea al calendario',
            // todosnuestrosservicios: 'Todos nuestros servicios',
            informacionimportante: 'Información importante',
            // bienvenido: 'Bienvenido a ',
            condicionesalquiler: 'Condiciones de alquiler',
            espana: 'Bienvenidos a España',
            madrid: 'Bienvenidos a Madrid'
        },
        panelconsejera: {
            hola: 'Hola',
            nuestracompania: 'Nuestra Compañía <b>Steps Relocation, SL</b> ha sido contratada por su empresa, <span class="bold">{empresa}</span>, para la prestación a Vd. y a su familia, de los servicios de “relocation”.',
            nuestracompania_rrhh: 'Nuestra Compañía <b>Steps Relocation, SL</b> ha sido contratada por su empresa, <span class="bold">{empresa}</span>, para la prestación a su trabajador, de los servicios de “relocation”.',
            consejeraasignada: 'Su consejera asignada es',
            preferencias: 'Preferencias',
            misservicios: 'Mis servicios'
        },
        modalnuevotrl: {
            bienvenido: 'Bienvenido',
            bienvenidomadrid: 'Bienvenido a Madrid',
            nuestracompania: 'Nuestra Compañía <b>Steps Relocation, SL</b> ha sido contratada por su empresa, <span class="bold">{empresa}</span>, para la prestación a Vd. y a su familia, de los servicios de “relocation”.',
            tusservicios: 'Estos son tus servicios',
            aceptacionpolitica: 'Aceptación de la Política de Privacidad',
            parapodercomenzar: 'Para poder comenzar con sus gestiones, primero necesitamos que acepte la Política de Privacidad para autorizarnos a poder guardar sus datos. Puede consultar nuestra política de Privacidad haciendo click aquí.',
            politica: `Sus datos personales no serán publicados. Los datos de carácter personal aportados, así como los datos de sus hijos menores de 14 años, y que se encuentran bajo su patria potestad, se tratan de conformidad con la normativa reguladora de la protección de datos de carácter personal vigente en cada momento, a día de hoy, en la Unión Europea, el Reglamento UE/2016/679, Reglamento General de Protección de Datos (RGPD). Sus datos se incorporan al fichero denominado “Clientes (Familia)” responsabilidad de Steps Relocation, SL.<br>
        <b>Información básica de la política de privacidad:</b><br>
        <b>Datos del responsable</b> Steps Relocation, SL  •  <b>CIF</b> B83325571  •  <b>Domicilio social</b> c/ Castillo de Aysa 2D  •  <b>Tfno.</b> (+34.) 810 526 434  •  <b>CEO</b> Dª Lydia Martínez García  • <b>Email</b> lmartinez@stepsrelocation.com<br>
        Finalidad: La finalidad del tratamiento es la prestación del servicio de “relocation” al Cliente.<br>
        <b>Base jurídica</b> el Contrato suscrito.<br>
        <b>Destinatarios</b> No se ceden datos a terceros, salvo obligación legal. Steps Relocation, SL podrá comunicar los datos personales a otros partners ubicados fuera del EEE, en caso de que los servicios deban ser prestados fuera de España, asegurando que dicha transferencia no supondrá ningún riesgo para los derechos y libertades de los interesados puesto que se efectuará de conformidad con lo dispuesto en el art.  44 y siguientes del Reglamento Europeo de protección de datos.<br>
        <b>Plazo de conservación de su información</b> Los datos personales que proporcione se conservarán durante un plazo de 6 años a partir de la realización de los servicios, manteniéndolos bloqueados hasta la prescripción de posibles acciones de responsabilidad.<br>
        <b>Derechos:</b> Puede ejercer sus derechos de acceso, rectificación, supresión y portabilidad de sus datos, limitación y oposición a su tratamiento, cuando procedan ante Steps Relocation, SL, Dpto. Administración, con domicilio en c/ Castillo de Aysa 2D, 28043 Madrid  o en la dirección de correo electrónico lopd@stepsrelocation.com<br>
        Asimismo, le informamos de que puede presentar una reclamación ante la Autoridad de Control en materia de Protección de Datos competente, la Agencia Española de Protección de Datos (https://www.aepd.es), especialmente cuando no haya obtenido satisfacción en el ejercicio de sus derechos.<br>
        <b class="link"><a href="/#/politicaPrivacidad" target="blank">Información sobre la política de privacidad.</a></b>`,
            titular: 'Titular',
            heleido: 'He leído, entiendo y acepto la Política de Privacidad.',
            conyuge: 'Cónyuge',
            soloencaso: 'Solo en caso de que sus hijos vayan a ser trasladados con usted.',
            indicanos: 'indícanos tus preferencias',
            conlassiguientes: 'Con las siguientes preguntas, obtendremos una imagen clara de sus requisitos de traslado, que nos permitirán proporcionarle un servicio personalizado de acuerdo a sus necesidades y preferencias.',
            datospersonalestab: 'DATOS PERSONALES',
            preferenciastraslado: 'PREFERENCIAS TRASLADO',
            colegios: 'COLEGIOS',
            tabhijos: 'HIJOS',
            datospersonales: 'Datos personales',
            nombre: 'Nombre',
            apellidos: 'Apellidos',
            nacionalidad: 'Nacionalidad',
            direcionactual: 'Dirección actual',
            pasaporte: 'Pasaporte',
            imagenpasaporte: 'Imagen del pasaporte',
            datoscontacto: 'Datos de contacto',
            emailprofesional: 'Email profesional',
            emailpersonal: 'Email personal',
            movil: 'Móvil',
            datosconyuge: 'Datos de cónyuge',
            sealoja: '¿Se realoja tu cónyuge contigo?',
            email: 'email',
            traslado: 'Traslado',
            fechatraslado: 'Fecha traslado',
            fechadisponible: 'Fecha/s disponible/s para visitas',
            fechaentrar: 'Fecha en la que le gustaría entrar en la vivienda',
            cuantotiempo: '¿Cuánto tiempo quiere alquilar la vivienda?',
            presupuesto: '¿Cuál es su presupuesto?',
            recuerde: 'Recuerde que los gastos (suministros) no se suelen incluir en la renta.',
            vivienda: 'Vivienda',
            tipovivienda: 'Tipo de vivienda',
            piso: 'Piso',
            casa: 'Casa',
            metroscuadrados: 'Metros cuadrados deseados',
            nhabitaciones: 'Número de habitaciones',
            estado: 'Estado',
            amueblada: 'Amueblada',
            sinamueblar: 'Sin amueblar',
            estilo: 'Estilo',
            clasico: 'Clásico',
            moderno: 'Moderno',
            otro: 'otro',
            caracteristicas: 'Características',
            piscina: 'Piscina',
            jardin: 'Jardín',
            terraza: 'Terraza',
            zonasinfantiles: 'Zonas infantiles',
            habitacionservicio: 'Habitación de servicio',
            otraspreferencias: 'Otras preferencias',
            centro: 'En el centro',
            afueras: 'En las afueras',
            cercaoficina: 'Cerca de la oficina',
            cercacolegio: 'Cerca del colegio',
            cercametro: 'Cerca del metro/FGC',
            soleado: 'Soleado',
            zonatranquila: 'Zona tranquila',
            preferenciasareas: 'Preferencias de áreas residenciales',
            garaje: 'Garaje',
            ncoches: 'Número de coches',
            incluidoenpresupuesto: 'Incluido en el presupuesto',
            traemascota: '¿Trae mascota?',
            si: 'Sí',
            no: 'No',
            encasoafirmativo: 'En caso afirmativo, indíquenos de qué tipo',
            otros: 'Otros',
            nhijos: 'Número de hijos',
            hijo: 'Hijo/a',
            sexo: 'Sexo',
            hombre: 'Hombre',
            mujer: 'Mujer',
            fechanacimiento: 'Fecha de nacimiento',
            curso: 'Curso',
            idiomas: 'Idiomas',
            preferencias: 'Preferencias',
            tipocolegio: 'Tipo de colegio',
            concertado: 'Concertado',
            privado: 'Privado',
            publicos: 'Públicos',
            tipoeducacion: 'Tipo de educación',
            alemana: 'Alemana',
            americana: 'Americana',
            britanica: 'Británica',
            espanola: 'Española',
            francesa: 'Francesa',
            otras: 'Otras',
            paracontinuar: 'Para continuar debes de aceptar la Política de privacidad',
            continuar: 'Continuar',
            guardarsalir: 'Guardar y salir',
            scroll: "Haz scroll hasta el final para rellenar todos los datos.",
            back: "Atrás"
        },
        pag_servicios: {
            nuestrosservicios: 'Nuestros servicios',
            vivienda: 'Vivienda',
            otros: 'Otros',
            establecimiento: 'Establecimiento',
            inmigración: 'Inmigración',
            coches: 'Coches',
            fiscal: 'Fiscal',
            volver: 'Volver atrás',
            new: "Nuevo",
            service: "Servicio",
            services: "Servicios",
            package: "Paquete",
            packages: "Paquetes",
            servicesAndPackages: "Servicios y Paquetes",
            categories: "Categorías",
            all: "Todos",
            find: "Buscar un servicio o paquete",
            filter: "Filtrar servicios/paquetes"
        },
        servicios: {
            1: {
                nombre: 'Alojamiento temporal',
                info: 'Elaboraremos una breve lista de opciones de alojamiento temporal que estén disponibles y te acompañamos a visitar 3 opciones, negociamos condiciones favorables y coordinamos la reserva de la vivienda seleccionada. Acompañamiento a la firma del contrato.'
            },
            2: {
                nombre: 'Alquiler de muebles',
                info: 'Organizamos el alquiler temporal de muebles para tu nueva casa. Ofrecemos apoyo durante la selección, reserva, pagos y soporte telefónico el día de la entrega.'
            },
            3: {
                nombre: 'Alta como empleador',
                info: 'Necesario para poder contratar ayuda doméstica. Todas las personas que contratan trabajadores por primera vez, deben solicitar el registro como empleadores en la Seguridad Social Española.'
            },
            4: {
                nombre: 'Apoyo a la pareja',
                info: 'Le informamos sobre diferentes actividades, asociaciones, clubs, ONG’s, educación, cursos, etc, para que tu experiencia en el nuevo destino sea productiva.'
            },
            5: {
                nombre: 'Asistencia telefónica',
                info: 'Le prestamos asistencia telefónica de lunes a viernes en horario laboral (de 9:00 a 19:00)'
            },
            6: {
                nombre: 'Aut. residencia - altamente cualificados',
                info: 'Información y asesoramiento sobre el procedimiento. Preparación del expediente, presentación de la solicitud ante las autoridades, acompañamiento a la solicitud de la tarjeta de residencia así como a la recogida tras la llegada del extranjero a España.'
            },
            7: {
                nombre: 'Aut. residencia - emprendedores',
                info: 'Información y asesoramiento sobre el procedimiento. Preparación del expediente, presentación de la solicitud ante las autoridades, acompañamiento a la solicitud de la tarjeta de residencia así como a la recogida tras la llegada del extranjero a España.'
            },
            8: {
                nombre: 'Ayuda doméstica',
                info: 'Te pondremos en contacto con agencias de servicio domestico y te presentaremos al gerente. Haremos seguimiento de las entrevistas. Alta en la seguridad social del empleado y empleador.'
            },
            9: {
                nombre: 'Búsqueda de colegio',
                info: 'Asesoramiento sobre diferentes colegios basándonos en tu cuestionario. Coordinación de visitas y acompañamiento a 3 colegios.  Asistencia con los requisitos de matriculación. Seguimiento sobre el proceso de admisión.'
            },
            10: {
                nombre: 'Búsqueda de parking',
                info: 'Buscamos una plaza de parking cerca de tu nuevo apartamento, de acuerdo a tus requerimientos y presupuesto. Negociación del contrato y coordinación de pagos'
            },
            11: {
                nombre: 'Búsqueda de vivienda',
                info: 'Identificación de las necesidades. Te enviaremos por email opciones que cuadren con los requerimientos descritos en el cuestionario (siempre que sean realistas). Un día de visitas acompañadas a unas 6-8 opciones preseleccionadas por ti. Las visitas serán de lunes a viernes en horario laboral. Negociación de contrato, acompañamiento a la firma e inventario fotográfico.'
            },
            12: {
                nombre: 'Canje carnet de conducir (EU)',
                info: 'Información completa sobre el trámite, documentación y requisitos. Preparación del expediente y reserva de cita previa. Acompañamiento a la presentación y seguimiento con el departamento de tráfico.  Gestión de problemas. Tu carnet de conducir debe estar en vigor.'
            },
            13: {
                nombre: 'Certificado de Registro UE',
                info: 'Información y asesoramiento sobre el procedimiento, requisitos y documentos. Preparación del expediente. Comunicación con la compañía, el ciudadano extranjero y las autoridades. Acompañamiento a la presentación. Este certificado incluye el número NIE.'
            },
            14: {
                nombre: 'Compra vivienda',
                info: 'Asesoramiento sobre las diferentes zonas. Selección de viviendas que se ajusten a las preferencias previamente descritas en el cuestionario (siempre que sean realistas). Organización de visitas con agentes inmobiliarios y propietarios. Un día de visitas acompañadas. Negociación del contrato de compra-venta, comprobación en el Registro de la Propiedad y estado del pago de impuestos. Negociación del contrato de arras (contrato privado previo a la compra del contrato en el que se establecen las condiciones de compra y en las que se abona el 10% del valor de la propiedad. Acompañamiento al notario.'
            },
            15: {
                nombre: 'Comunicación de desplazamiento',
                info: 'Información y asesoramiento sobre el procedimiento de comunicación del desplazamiento a la oficina de empleo. Preparación de expediente. Comunicación con la compañía, el ciudadano extranjero y las autoridades.'
            },
            16: {
                nombre: 'Trámites administrativos',
                info: 'Te informaremos sobre los trámites administrativos necesarios para estar completamente instalado en tu nuevo país.'
            },
            17: {
                nombre: 'Apertura de cuenta bancaria',
                info: 'Tu consejera encontrará la sucursal más conveniente del banco elegido y te ayudará con la presentación de la documentación para obtener tarjetas de crédito, etc y le acompañaremos a la sucursal bancaria.'
            },
            19: {
                nombre: 'Des-registro coche',
                info: 'Información y asesoramiento sobre el procedimiento, requisitos y documentos. Preparación del expediente y presentación ante las autoridades.'
            },
            20: {
                nombre: 'Des-registro empadronamiento',
                info: 'Información y asesoramiento sobre el trámite, requisitos y documentos. '
            },
            21: {
                nombre: 'Des-registro certificado de registro UE',
                info: 'información y asesoramiento sobre el procedimiento, requisitos y documentos. Presentación ante las autoridades.'
            },
            22: {
                nombre: 'Empadronamiento',
                info: 'Información y asesoramiento sobre el trámite, requisitos y documentos. Acompañamiento al Ayuntamiento.'
            },
            23: {
                nombre: 'Emprendedores - Renovacion',
                info: ''
            },
            25: {
                nombre: 'Gestión de mudanzas',
                info: 'Contactamos con la empresa de mudanzas, confirmamos el embalaje, la recogida y fechas de entrega. Coordinación de todo el proceso.'
            },
            26: {
                nombre: 'Legalización vehículo',
                info: 'Información complete sobre el proceso, preparación del expediente y presentación de la solicitud. Coordinación de la cita con el centro de ITV así como en el taller si es necesario. Obtención y envío de las nuevas matrículas.'
            },
            27: {
                nombre: 'Inclusión de beneficiarios Seguridad Social',
                info: 'Este procedimiento es obligatorio previo a la solicitud de las tarjetas sanitarias. Información sobre el trámite, preparación del expediente, presentación de la solicitud y recogida de la resolución.'
            },
            28: {
                nombre: 'Inventario',
                info: 'Inspección de la vivienda, verificación de las condiciones de la misma y realización de inventario fotográfico.'
            },
            29: {
                nombre: 'Look&see trip',
                info: 'Tu consejero te explicará las condiciones de vida, zonas residenciales y características de alquiler en un viaje de familiarización antes de tu traslado. Información sobre centros de salud, administraciones, etc. Te enseñaremos un máximo de 4 ejemplos de vivienda.'
            },
            30: {
                nombre: 'Acompañamiento adicional acompañado - 1dia',
                info: 'Acompañamiento durante un día o  dos medios días (de 10:00 a 13:30) a un tour por el centro de la ciudad. El tiempo de su consejero puede utilizarse para cubrir cualquier necesidad específica que tengas. Comida en uno de los restaurantes de moda de Madrid.'
            },
            31: {
                nombre: 'Mascotas',
                info: 'Organizamos una cita con un veterinario local, gestionamos servicios de paseadores de perros y buscamos residencia para cuando estés fuera.'
            },
            32: {
                nombre: 'Negociación de contrato',
                info: 'Asistencia durante la negociación. Revisión y adaptación del contrato de arrendamiento. Acompañamiento durante la firma y la entrega de llaves.'
            },
            33: {
                nombre: 'Certificado NIE',
                info: 'Información sobre el trámite, preparación del expediente, presentación de la solicitud y recogida de la resolución.'
            },
            34: {
                nombre: 'Nº Seg. Social (NAF)',
                info: 'Información sobre el trámite, preparación del expediente, presentación de la solicitud y recogida de la resolución.'
            },
            35: {
                nombre: 'Onboarding support',
                info: 'Apoyo a los nuevos empleados que se incorporan a la compañía actuando como punto de contacto para cualquier consulta que pueda tener antes de la fecha de inicio y durante el periodo de adaptación. Coordinación con los diferentes departamentos para la obtención del escritorio, ordenador y otros recursos.'
            },
            36: {
                nombre: 'Paquete de bienvenida',
                info: 'Carta/email de presentación, información sobre la ciudad de destino. Estudio de las necesidades personales y/o de la familia y llamada de contacto si fuera necesario. Acceso a la Intranet de Steps Relocation.'
            },
            37: {
                nombre: 'Programa Visar',
                info: 'Información y asesoramiento sobre el procedimiento. Preparación del expediente, presentación de la solicitud ante las autoridades, acompañamiento a la solicitud de la tarjeta de residencia así como a la recogida.'
            },
            38: {
                nombre: 'Régimen tributario especial expatriados',
                info: 'Revisión del caso. Explicación al empleado de las características especificaciones de este régimen y las obligaciones formales. Registro fiscal. Notificación de la opción por el régimen especial de acuerdo al modelo 149. Preparación del expediente.'
            },
            39: {
                nombre: 'Registro Consulado/Embajada',
                info: 'Información sobre el trámite y preparación del expediente. Obtención de cita previa siempre que sea posible.'
            },
            40: {
                nombre: 'Renovación certificado de Registro UE',
                info: 'Información y asesoramiento sobre el procedimiento, requisitos y documentos. Preparación del expediente. Comunicación con la compañía, el ciudadano extranjero y las autoridades. Acompañamiento a la presentación. Este certificado incluye el número NIE.'
            },
            41: {
                nombre: 'Segunda búsqueda de vivienda',
                info: 'Identificación de las necesidades. Te enviaremos por email todas las opciones disponibles en el mercado que cuadren con los requerimientos descritos en el cuestionario (siempre que sean realistas). Un día de visitas acompañadas a unas 6/8 opciones pre-seleccionadas por ti. Las visitas serán de lunes a viernes en horario laboral. Negociación del contrato, acompañamiento a la firma e inventario fotográfico.'
            },
            42: {
                nombre: 'Servicio cierre',
                info: ''
            },
            43: {
                nombre: 'Suministros',
                info: 'Conexión de suministros de agua, electricidad, gas, internet y teléfono. Organización de domiciliaciones bancarias.'
            },
            44: {
                nombre: 'Suministros comprobación',
                info: ''
            },
            45: {
                nombre: 'Tarjetas sanitarias',
                info: 'Información sobre el trámite y acompañamiento personal al Centro de Salud.'
            },
            46: {
                nombre: 'SER (Servicio de estacionamiento Regulado)',
                info: 'Este trámite permite aparcar en la calle, dentro de los límites de tu barrio. Información sobre el procedimiento y acompañamiento a la solicitud.'
            },
            47: {
                nombre: 'Variación de datos en la Seguridad Social',
                info: 'Información y asesoramiento sobre el procedimiento, requisitos y documentos. Preparación del expediente. '
            },
            48: {
                nombre: 'Aut. residencia - altamente cualificados – dependiente',
                info: 'Información y asesoramiento sobre el procedimiento. Preparación del expediente, presentación de la solicitud ante las autoridades, acompañamiento a la solicitud de la tarjeta de residencia así como a la recogida tras la llegada del extranjero a España.'
            },
            49: {
                nombre: 'Aut. residencia - emprendedores – dependiente',
                info: 'Información y asesoramiento sobre el procedimiento. Preparación del expediente, presentación de la solicitud ante las autoridades, acompañamiento a la solicitud de la tarjeta de residencia así como a la recogida tras la llegada del extranjero a España.'
            },
            50: {
                nombre: 'Certificado de Registro UE – dependiente',
                info: 'Información y asesoramiento sobre el procedimiento, requisitos y documentos. Preparación del expediente. Comunicación con la compañía, el ciudadano extranjero y las autoridades. Acompañamiento a la presentación. Este certificado incluye el número NIE.'
            },
            51: {
                nombre: 'Emprendedores - Renovacion',
                info: ''
            },
            52: {
                nombre: 'Renovación certificado de Registro UE – dependiente',
                info: 'Información y asesoramiento sobre el procedimiento, requisitos y documentos. Preparación del expediente. Comunicación con la compañía, el ciudadano extranjero y las autoridades. Acompañamiento a la presentación. Este certificado incluye el número NIE.'
            },
            new: 'Nuevo',
            servicesAndPackages: 'Servicios y Paquetes',
            services: 'Servicio',
            package: 'Paquete'
        },
        viviendas: {
            viviendas: 'Viviendas',
            seleccionadassegun: 'seleccionadas según tus preferencias',
            ordenar: 'Ordenar:',
            fechadeincorporacion: 'Fecha de incorporación',
            ultimamodificacion: 'Última modificación',
            precio: 'Precio',
            emes: '€/mes',
            ultmodificacion: 'Últ. modificación',
            notenemosaunviviendas: 'No tenemos ninguna viviendas con estas características',
            suconsejeraaun: 'Su consejera aún no le ha asignado ninguna vivienda',
            hab: 'hab.',
            ascensor: 'ascensor ',
            piscina: 'piscina ',
            jardin: 'jardín ',
            terraza: 'terraza ',
            piso: 'Piso',
            casa: 'Casa',
            newHouse: 'Nueva vivienda',
            sent: 'Ya ha sido enviada',
            preferences: "PREFERENCIAS",
            yes: "Si",
            no: "No",
        },
        fichatrl: {
            uploadedByUser: 'Subido por el usuario',
            uploadedBySteps: 'Subido por Steps Relocation',
            advice: 'Recuerda que los nombres de los archivos no deben contener tildes ni caracteres de puntuación o símbolos.<br>\n' +
                'Tamaño de archivo máximo 16Mb.',
            uploadFile: 'Subir un archivo',
            edited: "Datos del TRL editados correctamente",
            saved: "Datos guardados correctamente",
            personalData: "Datos personales",
            documents: "Documentos",
            moreServices: "Más servicios",
            supplies: "Suministros",
            houseAndContract: "Vivienda y contrato",
            preferences: "Preferencias de traslado",
            info: "Info personal",
            usersTitle: "Usuarios > Ficha de usuario",
            schools: "Colegios",
            gender: "Sexo",
            passport: "Pasaporte / DNI",
            passportImage: "Imagen del pasaporte / DNI",
            contactData: "Datos de contacto",
            downloadContract: "Download contract",
            rentContract: "Contrato de alquiler",
            contractStartDate: "Fecha inicio contrato",
            requiredDuration: "Duración obligatoria",
            preAdvice: "Preaviso",
            rent: "Renta",
            contractOwner: "Contrato a nombre de",
            signedBy: "Firmado por",
            deposit: "Fianza",
            depositBy: "Fianza pagada por",
            depositCert: "Depósito/aval",
            depositCertPaidBy: "Depósito/aval pagado por",
            agencyCommission: "Comisión agencia",
            agencyCommissionPaidBy: "Comisión agencia pagada por",
            photoInventory: "Inventario fotográfico",
            extendableContract: "Contrato prorrogable",
            presence: "Presencia check-in",
            tenant: "Inquilino",
            counselor: "Consejera",
            agent: "Agente",
            owner: "Propietario",
            notes: "Notas",
            insuranceTenant: "Seguro hogar (inquilino)",
            insuranceOwner: "Seguro hogar (propietario)",
            name: "Nombre",
            phone: "Teléfono",
            policyNumber: "Nº póliza",
            email: "Email",
            account: "Cta.bancaria",
            house: "Vivienda",
            address: "Dirección",
            service: "SERVICIO",
            startEnd: "INICIO/FIN",
            schedule: "AGENDA",
            addTask: "Añadir tarea al calendario",
            company: "Compañía",
            associatedPhone: "Teléfono asociado",
            refNumber: "Nº ref",
            verification: "Comprobación",
            others: "Otros",
            date: "Fecha alta/domiciliación",
            holder: "Titular",
            reading: "Lectura",
            visibleTR: "Visible para TRL y RRHH",
            noVisibleTR: "No visible para TRL y RRHH",
            notifyEmail: "Notificar por email",
            noTask: "Aún no hay tareas para este servicio",
            depositDevolution: "Devolución fianza",
            TLRNotified: "Notificado al TRL",
            nationality: "Nacionalidad",
            lastname: "Apellidos",
            preferedLang: "Idioma preferido",
            english: "Inglés",
            spanish: "Español",
            actualAddress: "Dirección actual",
            downloadImage: "Descargar imagen",
            download: "Descargar",
            professionalEmail: "Email profesional",
            personalEmail: "Email personal",
            mobile: "Móvil",
            conyData: "Datos del cónyuge",
            conyAsk: "¿Se realoja tu cónyuge contigo?",
            lang: "Idiomas",
            visibleData: "Datos bancarios (solo visible para Steps Relocation)",
            bank: "Banco",
            move: "Traslado",
            moveDate: "Fecha traslado",
            desireDate: "Fecha entrada deseada",
            availableDate: "Fecha disponible para visitas (de lunes a viernes)",
            budget: "Presupuesto",
            rentDuration: "Duración alquiler",
            area: "Metros cuadrados",
            roomsNumber: "Número de habitaciones",
            type: "Tipo",
            style: "Estilo",
            state: "Estado",
            characteristics: "Características",
            otherpreferences: "Otras preferencias",
            residentialAreas: "Áreas residenciales",
            garage: "Garaje",
            pets: "Mascotas",
            birthday: 'Fecha de nacimiento',
            curse: "Curso",
            schoolPreferences: "Preferencias colegio",
            educationType: 'Tipo de educación',
            companyData: "Datos para la empresa",
            adviceDate: "Fecha aviso",
            firstContactDate: 'Fecha 1er contacto con TRL',
            arriveDate: "Fecha llegada",
            visitDate: "Fecha visita a casas",
            schoolDate: "Fecha búsqueda colegios",
            signDate: "Fecha firma contrato",
            entranceDate: "Fecha de entrada",
            homeData: "Datos de la vivienda",
            catastral: "Referencia catastral",
            ownerName: "Nombre del propietario",
            ownerAddress: 'Dirección propietario',
            ownerPhone: "Teléfono propietario",
            ownerEmail: "Email propietario",
            bankAccount: "Cuenta bancaria (IBAN)",
            onchargeName: "Nombre encargado",
            agency: "Agencia inmobiliaria",
            song: "Hijo/a"
        },
        fichavivienda: {
            estaViviendaNoExiste: 'Esta vivivienda ya no está disponible o ha sido eliminada',
            volver: 'Volver a Viviendas',
            disponible: 'Disponible',
            nodisponible: 'No disponible',
            emes: '€/mes',
            caracteristicasbasicas: 'Características básicas',
            planta: 'Planta',
            casa: 'Casa',
            habitaciones: 'habitaciones',
            banos: ' baños',
            piscina: 'Piscina',
            jardin: 'Jardín',
            terraza: 'Terraza',
            zonasinfantiles: 'Zonas infantiles',
            habitaciondeservicio: 'Habitación de servicio',
            soleado: 'Soleado',
            zonatranquila: 'Zona tranquila',
            aireacondicionado: 'Aire acondicionado',
            calefaccion: 'Calefacción',
            trastero: 'Trastero',
            cercametro: 'Cerca del metro/FGC',
            estado: 'Estado',
            Excelente: 'Excelente',
            'Buenas condiciones': 'Buenas condiciones',
            'Nueva construcción': 'Nueva construcción',
            Reformado: 'Reformado',
            'A reformar': 'A reformar',
            estilo: 'Estilo',
            'Clásico': 'Clásico',
            equipamiento: 'Equipamiento',
            Amueblado: 'Amueblado',
            'Sin amueblar': 'Sin amueblar',
            'Parcialmente amueblado': 'Parcialmente amueblado',
            Moderno: 'Moderno',
            Otro: 'Otro',
            garaje: 'Garaje',
            plazas: ' plazas',
            inluidoenelprecio: 'Incluido en el precio',
            noincluidoenprecio: 'No incluido en el precio',
            mascota: 'Mascotas',
            mascotasi: 'Sí',
            gastosdecomunidad: 'Gastos de comunidad:',
            tipodecontrato: 'Tipo de contrato:',
            Alquiler: 'Alquiler',
            Compra: 'Compra',
            'Alquiler temporal': 'Alquiler temporal',
            condicionesalquiler: 'Condiciones de alquiler:',
            barrio: 'Barrio',
            descripcion: 'Descripción',
            piso: 'Piso'
        },
        paginabasica: {
            volver: 'Volver atrás',
            politicadeprivacidad: 'Politica de privacidad',
            lerecomendamosquelea:
                `<p><strong>LE RECOMENDAMOS QUE LEA Y COMPRENDA NUESTRA POLÍTICA DE PRIVACIDAD ANTES DE FACILITAR SUS
                        DATOS PERSONALES Y OTORGAR EL CONSENTIMIENTO PARA SU TRATAMIENTO.</strong></p>
                <p><strong>1</strong><strong>.- ¿Quién es el responsable del tratamiento de tus datos?.</strong></p>
                <p>Steps Relocation, SL, con domicilio en c/ Castillo de Aysa nº 2D, 28043 Madrid, provista de NIF nº
                    B83325571, representada por su Consejera Delegada, Dª Lydia Martínez García
                    (lmartinez@stepsrelocation.com).</p>
                <p><strong>&nbsp;2.- ¿Qué datos tuyos tratamos?.</strong></p>
                <p>2.1 Datos que nos han sido facilitados por el usuario (Contacto) mediante formulario web, y que se
                    corresponden con los siguientes datos personales: nombre, apellidos, dirección, email y teléfono.
                </p>
                <p>2.2 Datos que nos han sido facilitados por la Familia (Cliente) mediante formulario en papel y a
                    través de la intranet: nombre y apellidos de los padres o tutores, móvil y teléfono fijo, dirección,
                    nº de pasaporte, DNI o tarjeta de residencia, email; nombre, apellidos, fecha de nacimiento y
                    colegio de los hijos.</p>
                <p><strong>3.- ¿Con qué finalidad tratamos tus datos personales y cuál es la base
                        jurídica?</strong><strong>&nbsp;</strong></p>
                <p>Tratamos tus datos con las siguientes finalidades, base jurídica y plazos de conservación, descritas
                    a continuación:</p>
                <p>3.1 Contactos.</p>
                <p>Finalidad: gestionar la relación comercial (atender las consultas y/o cuestiones planteadas).</p>
                <p>Base jurídica: consentimiento.</p>
                <p>Plazos de conservación: Los datos personales que proporcione se conservarán mientras no solicite su
                    supresión y, en caso de que no la solicite, transcurrido el plazo de 1 año a partir de la última
                    confirmación de interés por su parte.</p>
                <p>3.2 Cliente.</p>
                <p>Finalidad: prestación del servicio de relocation al Cliente (ejem: servicios de búsqueda de vivienda,
                    mudanza, colegio para los hijos, procesos migratorios y de establecimiento, canjes de permisos de
                    conducir).</p>
                <p>Base jurídica: el Contrato suscrito.</p>
                <p>Plazos de conservación: Los datos personales que proporcione se conservarán durante un plazo de 6
                    años a partir de la realización de los servicios, de acuerdo a la política sobre eliminación
                    documental de Steps Relocation, S.L, manteniéndolos bloqueados hasta la prescripción de posibles
                    acciones de responsabilidad.</p>
                <p><strong>4.- ¿Quién es el destinatario de tus datos?</strong></p>
                <p>4.1 Comunicación de datos:</p>
                <ol>
                    <li>Los datos personales tratados se comunican a terceros, en cumplimiento de obligaciones legales.
                    </li>
                    <li>Asimismo, Steps Relocation, SL, para la efectiva prestación del servicio, podrá comunicar los
                        datos personales a otros <em>partners </em>ubicados fuera del EEE<em>,</em> que no proporcionen
                        un nivel de protección de datos equiparable al de la Unión Europea, como Estados Unidos. En
                        tales casos, le informamos de que transferimos sus datos con garantías adecuadas y siempre
                        guardando la seguridad de los mismos, asegurando que dicha transferencia se efectuará de
                        conformidad con lo dispuesto en el art. 44 y siguientes del Reglamento Europeo de Protección de
                        Datos, a:</li>
                </ol>
                <ul>
                    <li>un destinatario declarado de nivel adecuado por la Comisión Europea (de acuerdo a la información
                        publicada por la AEPD), o</li>
                    <li>certificado en Privacy Shield, o</li>
                    <li>a un destinatario con las garantías adecuadas, mediante la suscripción de las correspondientes
                        Cláusulas contractuales tipo adoptadas por la Comisión,</li>
                    <li>y/o con el consentimiento expreso del interesado.</li>
                </ul>
                <p>Puede solicitar evidencia de las garantías existentes enviando un email a <a
                        href="mailto:lopd@stepsrelocation.com">lopd@stepsrelocation.com</a>.</p>
                <p>4.2 Encargados del tratamiento</p>
                <p>Steps Relocation contará con la colaboración de terceros proveedores de servicios que pueden tener
                    acceso a sus datos personales y que tratarán los referidos datos en nombre y por cuenta de la
                    Compañía, como consecuencia de su prestación de servicios. Steps Relocation sigue unos criterios
                    estrictos de selección de proveedores de servicios con el fin de dar cumplimiento a sus obligaciones
                    en materia de protección de datos, y se compromete a suscribir con ellos el correspondiente contrato
                    de tratamiento de datos.</p>
                <p>En concreto, Steps Relocation contratará la prestación de servicios por parte de terceros proveedores
                    que desempeñan su actividad, a título enunciativo y no limitativo, en los siguientes sectores:
                    servicios de Relocation (búsqueda de vivienda, búsqueda de colegios, aperturas de cuenta bancaria,
                    etc. )suministro de mobiliario, integración cultural, servicios de mudanzas, servicios jurídicos,
                    contables y de gestoría, y empresas proveedoras de servicios informáticos.</p>
                <p><strong>5.- ¿Cuáles son sus derechos cuando nos facilita sus datos?</strong></p>
                <p>Los derechos que le asisten en relación al tratamiento de datos personales por parte de STEPS
                    RELOCATION son:</p>
                <ul>
                    <li><u>Derecho a solicitar el acceso</u> a tus datos personales</li>
                    <li><u>Derecho a solicitar su rectificación o supresión</u></li>
                    <li><u>Derecho a solicitar la limitación de tu tratamiento</u></li>
                    <li><u>Derecho a oponerse al tratamiento</u></li>
                    <li><u>Derecho a la portabilidad</u> de los datos</li>
                </ul>
                <p><strong>6.- ¿En qué consiste el derecho de acceso?.</strong></p>
                <p>Tendrá derecho a obtener confirmación de si se están tratando o no datos personales que le
                    conciernen, y a la siguiente información: los fines del tratamiento; las categorías de los datos que
                    se tratan; los destinatarios o las categorías de destinatarios a los que se han comunicado o serán
                    comunicados; de ser posible, el plazo previsto de conservación de los datos personales o, de no ser
                    posible, los criterios utilizados para determinar este plazo.</p>
                <p>En estos casos, le facilitaremos una copia de los datos personales objeto de tratamiento. Además,
                    cuando lo solicite por medios electrónicos, la información se facilitará en un formato electrónico
                    de uso común.</p>
                <p>Podrá ejercitar este derecho cada seis meses, salvo que exista causa legítima para solicitarlo, más
                    de una vez, en dicho periodo de seis meses y le informaremos sobre las actuaciones derivadas de su
                    petición en el plazo de un mes.</p>
                <p><u>Para ejercitar el derecho de acceso, </u>envíe un email a &nbsp;<a
                        href="mailto:belen@kinsaleconsulting.com">lopd@stepsrelocation.com</a> o remita una carta a la
                    atención del Dpto. Administración, con domicilio en c/ Castillo de Aysa 2D, 28043 Madrid.</p>
                <p><strong>7.- ¿En qué consiste el derecho de rectificación?</strong></p>
                <p>Tendrá derecho a obtener la rectificación de los datos personales inexactos que le conciernen, para
                    ello, tendrá que acompañar, cuando sea preciso, la documentación justificativa de la inexactitud o
                    carácter incompleto de los datos objeto del tratamiento.</p>
                <p><u>Para ejercitar el derecho de rectificación, </u>envíe un email a&nbsp; <a
                        href="mailto:belen@kinsaleconsulting.com">lopd@stepsrelocation.com</a> o remita una carta a la
                    atención del Dpto. Administración, con domicilio en c/ Castillo de Aysa 2D, 28043 Madrid.</p>
                <p><strong>8.- ¿En qué consiste el derecho de supresión?</strong></p>
                <p>Tendrá derecho a obtener la supresión de los datos personales que le conciernen cuando concurran una
                    de las circunstancias siguientes: que no sean necesarios en relación con los fines para los que
                    fueron recogidos o tratados; que retire el consentimiento y el tratamiento no se base en otro
                    fundamento jurídico; que se opongas al tratamiento y no prevalezcan otros motivos legítimos para el
                    tratamiento; que hayan sido tratados ilícitamente.</p>
                <p><u>Para ejercitar el derecho de supresión, </u>envíe un email a&nbsp; &nbsp;<a
                        href="mailto:belen@kinsaleconsulting.com">lopd@stepsrelocation.com</a> o remita una carta a la
                    atención del Dpto. Administración, con domicilio en c/ Castillo de Aysa 2D, 28043 Madrid.</p>
                <p><strong>9.- ¿En qué consiste el derecho a la limitación del tratamiento?</strong></p>
                <p>Tendrá derecho a obtener la limitación del tratamiento de los datos cuando se cumpla alguna de las
                    condiciones siguientes:</p>
                <ol>
                    <li>cuando haya impugnado la exactitud de tus datos personales, durante el plazo que permita al
                        responsable del fichero verificar la exactitud de los mismos;</li>
                    <li>en el supuesto de que considere que el tratamiento es ilícito y el responsable del fichero se
                        haya opuesto a la supresión de los datos personales y solicite en su lugar la limitación de su
                        uso;</li>
                    <li>que el responsable del fichero ya no necesite los datos personales para los fines del
                        tratamiento, pero Vd. los necesite para la formulación, el ejercicio o la defensa de
                        reclamaciones;</li>
                    <li>en el supuesto de que se haya opuesto al tratamiento, mientras se verifica si los motivos
                        legítimos del responsable del fichero prevalecen sobre los suyos.</li>
                </ol>
                <p>Cuando haya obtenido la limitación del tratamiento conforme el presente apartado, será informado por
                    el responsable del fichero.</p>
                <p><u>Para ejercitar el derecho a la limitación del tratamiento, </u>envíe un email a &nbsp;<a
                        href="mailto:belen@kinsaleconsulting.com">lopd@stepsrelocation.com</a> o remita una carta a la
                    atención del Dpto. Administración, con domicilio en c/ Castillo de Aysa 2D, 28043 Madrid.</p>
                <p><strong>10.- ¿En qué consiste el derecho a la portabilidad de los datos?</strong></p>
                <p>Tendrá derecho a recibir los datos personales que le conciernan, que haya facilitado al responsable
                    del tratamiento, en un formato estructurado, de uso común y lectura mecánica, y a transmitirlos a
                    otro responsable del tratamiento cuando: el tratamiento esté basado en el consentimiento, y se
                    efectúe por medios automatizados.</p>
                <p>Al ejercer su derecho a la portabilidad de los datos, tendrá derecho a que los datos personales se
                    transmitan directamente de responsable a responsable cuando sea técnicamente posible.</p>
                <p>El derecho a la portabilidad no se extenderá a los datos que el responsable del fichero hubiera
                    inferido a partir de datos que se deriven directamente del uso por dicho responsable de los
                    servicios prestados.</p>
                <p><u>Para ejercitar el derecho de portabilidad, </u>envíe un email a &nbsp;<a
                        href="mailto:belen@kinsaleconsulting.com">lopd@stepsrelocation.com</a> o remita una carta a la
                    atención del Dpto. Administración, con domicilio en c/ Castillo de Aysa 2D, 28043 Madrid.</p>
                <p><strong>11.- ¿En qué consiste el derecho de oposición?</strong></p>
                <p>Tendrá derecho a oponerse al tratamiento de datos que le conciernen, en cualquier momento. En caso de
                    que ejercite este derecho, el responsable del fichero dejará de tratar sus datos personales, salvo
                    que acreditemos motivos legítimos imperiosos para que el tratamiento prevalezca sobre sus intereses,
                    derechos y libertades, o para la formulación, del ejercicio o la defensa de reclamaciones.</p>
                <p><u>Para ejercitar el derecho de oposición, </u>envíe un email a&nbsp; &nbsp;<a
                        href="mailto:belen@kinsaleconsulting.com">lopd@stepsrelocation.com</a> o remita una carta a la
                    atención del Dpto. Administración, con domicilio en c/ Castillo de Aysa 2D, 28043 Madrid.</p>
                <p>Adicionalmente, le informamos que puede dirigirse a la <u>Agencia Española de Protección de Datos</u>
                    para obtener información adicional acerca de sus derechos.</p>
                <p>También le informamos, en el caso de que se haya otorgado el consentimiento para alguna finalidad
                    específica, que tiene derecho a retirar el consentimiento en cualquier momento, sin que ello afecte
                    a la licitud del tratamiento basado en el consentimiento previo a su retirada.</p>
                <p>Asimismo, le informamos que puede presentar una reclamación ante la Autoridad de Control en materia
                    de Protección de Datos competente, la Agencia Española de Protección de Datos (https://www.aepd.es),
                    especialmente cuando no haya obtenido satisfacción en el ejercicio de sus derechos.</p>`,
            condicionesalquiler:
                `<h3 class="titulo">Condiciones de alquiler en España</h3><br>
          <p>En España los contratos están regulados por la “Ley de Arrendamientos Urbanos” o “LAU”. 
          La duración de los contratos habitualmente son de 1 año renovable a 5. Después de cinco años, el contrato puede ser ampliado a otros tres. 
          Los primeros seis meses son de obligatorio cumplimiento. Hay propietarios que exigen un año de obligado cumplimiento y se niegan a tener un inquilino que no lo asegure.</p>
          <p>En la mayoría de los casos, las viviendas se alquilan en la condición en las que están durante la visita. 
          No hay obligación para el propietario de hacer reparaciones menores o renovar la vivienda durante, al menos, los cinco años de arrendamiento. 
          Por ello, todos los cambios que te gustaría hacer en la vivienda, deben ser discutidos y aprobados antes de la firma del contrato de arrendamiento y ser enumerados en el mismo.</p>
          <p>La mayoría de los alojamientos se alquilan vacíos. Si la vivienda está sin amueblar, la cocina suele está equipada con electrodomésticos y armarios.  Si es necesario, se pueden alquilar muebles.</p>
          <p>El Real Decreto Ley 7/2019, del 1 de marzo, que regula los alquileres es muy beneficioso para los inquilinos. Sólo se aplican los términos específicos definidos por esta ley y las cláusulas particulares no pueden ir en contra de la ley.</p>
          <p>Los contratos de alquiler están escritos exclusivamente en castellano, no hay ninguna versión legal en inglés que pueda existir y pueden estar a nombre de una empresa o a nombre de un particular.</p>
          <p>Ningún alquiler estará 100% asegurado antes de que el contrato de arrendamiento se haya firmado por ambas partes o que hayas hecho un pago de reserva.</p>
          <p>En la firma del contrato de arrendamiento, el inquilino tendrá que pagar: 1) la fianza 2) los honorarios de la agencia inmobiliaria si los hay 3) garantías adicionales y 4) primer mes de renta (o prorrateo correspondiente).</p>
          <p><strong>NOTA IMPORTANTE</strong>: Si el piso tiene más de 300 metros cuadrados, es considerado “suntuoso” o el alquiler supera los 5000€, la Ley de Arrendamientos Urbanos no se aplica y 
          las condiciones de alquiler y garantías son negociadas en cada caso por la propiedad y el inquilino.</p>
          <h3 class="subtitulo">Fianza</h3>
          <p> La fianza legal suele ser un mes de alquiler, pero puede variar dependiendo de la vivienda. Se devuelve mas o menos en un mes tras la devolución de la vivienda, 
          siempre que no haya desperfectos en la vivienda y que los servicios se encuentren al corriente de pago.</p> 
          <h3 class="subtitulo">Garantías adicionales</h3>
          <p>Cubre impago y es algo que dependerá de cada propietario. Puede ser un depósito o un aval bancario.</p>
          <p>El aval bancario es una práctica normal en España y consiste en un depósito bancario para cubrir impagos. El banco bloquea el dinero en tu cuenta, y produce un documento firmado por Notario, que se entrega al propietario de la vivienda. Normalmente no está listo antes de 10 dias y el Banco pasa una tarifa mínima de mantenimiento.</p>
          <h3 class="subtitulo">Gastos de agencia (en caso de que se use)</h3>
          <p>La comisión de la agencia suele ser de 1 mes de renta + 21% de IVA y la suele pagar el inquilino. Esto puede variar dependiendo de en qué zona de España te encuentres. En algunos casos se calcula un porcentaje sobre el precio anual de la renta.</p>
          <h3 class="subtitulo">Obligaciones del inquilino y arrendador</h3>
          <p>La renta debe ser abonada antes del día 5 cada mes.</p>
          <p>El arrendatario tiene que comunicar al propietario cualquier problema de la vivienda en un plazo de 24 horas.</p>
          <p>El arrendatario se hace responsable de arreglar el deterioro por uso normal de la vivienda al igual que daños provocados por mal uso de la vivienda.</p>
          <p>El propietario se hará cargo de la reparación y/o sustitución de los servicios comunes que dejasen de funcionar.</p>
          <p>El arrendatario no podrá subarrendar la vivienda en ningún caso.</p> 
          <h3 class="subtitulo">Causas de terminación de arriendo (en general)</h3> 
          <ul>
            <li>- la falta de pago de una mensualidad</li>
            <li>- cuando en la vivienda arrendada no se destine al uso establecido</li>
            <li>- no cumplir con las obligaciones del contrato</li>
            <li>- daños causados por obras realizadas sin el permiso del arrendador</li>
            <li>- cuando en la vivienda tengan lugar actividades molestas, insalubres, nocivas, peligrosas o ilícitas</li>
            <li>- necesidad del arrendador de ocupar la vivienda arrendada a partir del primer año para destinarla a vivienda permanente para sí o sus familiares. Dicha comunicación deberá hacerse con algunos meses de antelación a la fecha en la 
            que la vivienda se vaya a necesitar</li>
          </ul>
          <h3 class="subtitulo">Seguro de vivienda</h3>
          <p>En España, no es obligatorio contratar una póliza de seguro de vivienda. Sin embargo, recomendamos contratar una 
          póliza de seguros de hogar. El inquilino debe asegurar la responsabilidad civil y objetos personales. De hecho, muchos propietarios insisten en ponerlo en el contrato como obligatorio. 
          <h3 class="subtitulo">Gastos adicionales para el inquilino</h3>
          <p>Los suministros tales como agua, gas, electricidad, teléfono e internet. Seguro de hogar y responsabilidad civil.</p>`,
            madrid:
                `
          <h3 class="titulo">Bienvenidos a Madrid</h3><br>
          <p>Madrid es la capital de España y una ciudad muy agradable, divertida y cosmopolita. Es el centro financiero y la sede del gobierno central (España está dividida en 17 comunidades autónomas). El idioma oficial es el castellano, pero en otras comunidades autónomas podrán escuchar catalán, gallego, valenciano, euskera... ¡no te preocupes, son bilingües!<br />
          Está situado en el centro del país, en la meseta castellana, a una altitud de 646 metros, lo que la convierte en la capital más alta de Europa. Muy bien situada para esquiar, ya que hay muy buenas pistas a solo una hora, en la Sierra de Guadarrama.<br />
          Tiene unos 3,5 millones de habitantes en el área metropolitana y llegamos hasta los 6,5 millones si<br />
          contamos los alrededores.<br />
          El mar Mediterráneo está a unos 350 km y las grandes ciudades de España como Barcelona, Sevilla o Bilbao están muy bien conectadas mediante AVE (tren de alta velocidad). Las ciudades como París, Londres, Roma y casi todas las capitales europeas están solo a un par de horas de avión.<br />
          Las temperaturas de Madrid son muy diferentes entre el verano y el invierno. Los meses de verano son extremadamente secos y calientes, con temperaturas que superan a veces los 40ºC, mientras que los inviernos son fríos y secos. Los meses de primavera y otoño son suaves y agradables.<br />
          España tiene uno de los índices de criminalidad más bajos de Europa. Pese a eso hay que tener cuidado con los ladrones de bolsos y carteras. Madrid no es una ciudad con mucha criminalidad, pero es mejor mantenerse alerta y tener cuidado al sacar dinero de un cajero, por ejemplo.<br />
          </p>

          <img src="images/infotrl/escudo_madrid.png" height="200px" style="display:block; margin: 0 auto;"/>
          <p>El escudo de Madrid es un oso apoyado en un madroño, de corona abierta y siete estrellas. Cada una de sus estrellas representa a las correspondientes estrellas principales de la constelación de la Osa Mayor, que se recorta sobre la sierra del Guadarrama.<br />
            Cuenta la leyenda que se eligió un oso como emblema en homenaje a un oso pardo que el rey Alfonso XI cazó en uno de los montes cercanos a la capital.<br />
            El oso estaba al principio unido a una torre, que sería sustituida posteriormente por un madroño. Estos árboles eran habituales en las afueras de la ciudad durante toda la época medieval.<br />
            </p>

          <h3 class="subtitulo">La gente de Madrid</h3>
          <p>Fuera de las ciudades y pueblos más pequeños, es difícil ver un verdadero castellano. El movimiento de la población ha hecho a la gente ser “española” en sentido general, especialmente a los madrileños, ya que <strong>Madrid está habitada por gente de todos los sitios de España.</strong><br />
           Sin embargo, si tuviésemos que describir a la gente de Madrid, deberíamos decir que son bastante abiertos. El tiempo que pasan con su familia es muy importante y como hemos dicho anteriormente, les encanta comer fuera y socializar.</p>
          <div style="margin-bottom: 40px; display: flex; justify-content:space-between; flex-wrap: wrap;">
            <img src="images/infotrl/gentemadrid1.png" height="200px" style="margin: 0 10px 10px 0; flex: 0 1 auto;"/>
            <div style="margin-right: 10px; flex: 0 1 auto; max-heigth:180px">
              <img src="images/infotrl/gentemadrid2.png" width="100%"/>
            </div>
            <img src="images/infotrl/gentemadrid3.png" height="200px" style="margin-right: 10px; flex: 0 1 auto;"/>
          </div>
          <p><strong>Agosto</strong> es un mes en el que Madrid está casi vacío, cosa que a muchos de nosotros nos encanta, ya que podemos llegar a tiempo a cualquier sitio, no hay atascos, y se encuentra sitio en el restaurante que uno desea si este está abierto. Sin embargo, no es un mes apropiado para buscar piso, ya que es posible que muchas agencias cierren e incluso que los dueños de los pisos a visitar estén fuera. Es mejor cambiar los planes y buscar uno o dos meses antes.</p>
          <p> A los madrileños les importa mucho su apariencia. Normalmente van elegantemente vestidos. Esto no quiere decir que no se acepten los atuendos deportivos (que son muy populares), pero raramente se ve a un madrileño salir a tomar algo o a trabajar con pinta descuidadamente abandonada. En la vida profesional, en la mayoría de los casos se usa corbata para los hombres y las mujeres visten “formalmente”. Últimamente hay que decir que las empresas han empezado a prescindir de la corbata y a introducir la vestimenta “casual” en las oficinas, sobre todo los viernes. Fíjate cuál es el código de vestimenta de tu oficina para ir en acorde. </p>
          <h3 class="subtitulo">JARDINES DE MADRID</h3> 
          <strong>CASA DE CAMPO</strong>
          <p>Situado sobre la margen derecha del Manzanares, es uno de los parques más importantes de Madrid, con sus casi <strong>1800 hectáreas</strong>, es el pulmón que oxigena Madrid. En época de Felipe II fue <strong>coto de caza</strong> de los reyes de España. Durante la Segunda República pasó a ser propiedad del pueblo de Madrid. Dentro de su perímetro se encuentra el Zoológico de Madrid, el Parque de Atracciones y un lago artificial. En torno a este lago, algunos agradables paseos que trepan por las colinas de la Casa de Campo permiten contemplar la vista más hermosa de Madrid al atardecer, cuando el sol se refleja en los muros del Palacio Real y de la catedral de la Almudena. Es el auténtico <strong>“skyline”</strong> de Madrid, más representativo de la ciudad que el perfil de sus rascacielos modernos.</p>
          <strong>MONTE DE EL PARDO</strong>
          <p> Actualmente es un parque natural, poblado con especies autóctonas, cerrado al público, salvo en algunas zonas.</p>
          <strong>PARQUE DEL OESTE</strong>
          <p>El mejor jardín paisajista de Madrid, se extiende por un largo terraplén que va desde la calle del Pintor Rosales hasta la ribera del Manzanares.</p>
          <strong>REAL JARDÍN BOTÁNICO</strong>
          <p> Jardín histórico trazado en 1781, promovido por Carlos III. Reúne más de <strong>30.000 especies vegetales</strong> de todo el mundo y un invernadero con plantas tropicales.</p> 
          <strong>PARQUE DEL RETIRO</strong>
          <p>Es el parque <strong>histórico-artístico</strong> más importante de la ciudad, creado durante el reinado de Felipe IV. Se encuentra situado en pleno corazón de la ciudad y cuenta con una superficie de <strong>118 hectáreas</strong> arboladas. Adornados sus paseos con numerosas estatuas y grupos escultórico, obra de importantes artistas, en el interior de su recinto se encuentra el observatorio astronómico edificado en 1790, el Palacio de Velázquez que alberga exposiciones temporales y el Palacio de Cristal, nacido como invernadero en el siglo pasado y hoy también sala de exposiciones. Tiene numerosos quioscos donde descansar tomando un refresco o un café. El Retiro se mantiene <strong> todos los días del año.</strong> El acceso es libre, excepto en los jardines de Cecilio Rodríguez (abiertos de 09:00 a 17:00 de lunes a viernes) y otras dependencias municipales. En el quiosco de la música la banda municipal actúa las mañanas de los domingos de primavera y verano. Tanto en la zona central donde se encuentra el estanque, como en los paseos circundantes multitud de artistas, músicos, magos o malabaristas muestran sus habilidades a los paseantes, sobre todo los fines de semana.</p>
          <h3 class="subtitulo">DONDE VIVIR EN MADRID (* documento AREAS)</h3>
          <p><strong>Chamberí</strong></p>
          <p>DESCRIPCIÓN: se encuentra al este de Moncloa y se extiende hasta la Castellana, donde ya se convierte en Salamanca. Chamberí puede presumir de una arquitectura magnífica; algunos de sus edificios son absolutamente preciosos como el Museo Sorolla, el Institute International e incluso el British Council. Puede presumir también plazas acogedoras y llenas de ambiente como la Plaza de Camberí o la Plaza de Olavide. Una de las mejores calles para tomar algo y cenar es la Calle Ponzano, donde puedes encontrar restaurantes exquisitos como el Bar Lambuzo o Sala del Despiece.
          Recomiendo Chamberí si quieres vivir cerca del centro pero no en pleno centro. Aquí, tendrás la posibilidad de andar a todas partes y vivir tus sitios preferidos sin tener que compartirlo demasiado con turistas. 
          Chamberí es un barrio antiguo, con lo cual la calidad de las casas no llega al nivel que podríamos encontrar en el barrio Salamanca y las tiendas y bares no marcan tanta tendencia como Malasaña y Chueca, pero si buscas un barrio auténtico, con la sensación de vivir en un pueblo con las comodidades modernas y prácticas, Chamberí es tu barrio.
          </p>
          <div style="margin-bottom: 40px; display: flex; justify-content:space-between; flex-wrap: wrap;">
          <img src="images/infotrl/chamberi1.png" height="200px" style="margin-right: 10px;"/>
          <img src="images/infotrl/chamberi2.png" height="200px" style="margin-right: 10px;"/>
          <img src="images/infotrl/chamberi3.png" height="200px" style="margin-right: 10px;"/>
          </div>
          <p><strong>Malasaña</strong></p>
          <p>DESCRIPCIÓN: Malasaña es conocido como la parte más “hipster” y alternativa de la ciudad. Esto se debe a su pasado rebelde, con vecinos que luchaban por lo que amaban (en 1802, los residentes organizaron un levantamiento contra Napoleón en la que hoy en día es la Plaza Dos de Mayo). La calle principal, al norte de Gran Vía, es la calle Fuencarral, paralela a la calle Hortaleza de Chueca. Las coloridas calles estrechas están llenas de cafés, restaurantes y tiendas vintage y variopintas. También podemos encontrar arte callejero, a los tatuadores más “in” del momento y “pop-up stores” que venden desde disfraces y ropa gótica hasta elementos de decoración y cupcakes. Encontrarás las calles, tiendas y plazas llenas de gente a cualquier hora del día o de la noche y su principal parada de metro, Tribunal, es el segundo punto de encuentro más popular para salir por la noche. La oferta noctura de Tribunal es amplia y encontramos de todo pero sobre todo se caracteriza por dar la bienvenida a un público indie y alternativo con locales eclécticos. Aunque decidas no vivir aquí, te recomendamos que visites sus calles tanto de día como de noche.</p>
          <div style="margin-bottom: 40px; display: flex; justify-content:space-between; flex-wrap: wrap;">
          <img src="images/infotrl/malasaña1.png" height="200px" style="margin-right: 10px;"/>
          <img src="images/infotrl/malasaña2.png" height="200px" style="margin-right: 10px;"/>
          <img src="images/infotrl/malasaña3.png" height="200px" style="margin-right: 10px;"/>
          </div>
          <p><strong>Chamartin</strong></p>
          <p>DESCRIPCIÓN: en el norte de la ciudad encontramos un Madrid más moderno, que da lugar al barrio de Chamartín. Esta zona marca el límite por el norte del centro de la ciudad y es más grande que los demás barrios. La zona está subdividida en áreas más pequeñas como Castilla y Prosperidad, pero todas están muy bien conectadas con el metro. El barrio se encuentra entre los barrios de Las Tablas y Salamanca y se considera el centro de negocios de Madrid. Aquí puedes encontrar la estación de trenes de Chamartín, Plaza Castilla, el estadio de Santiago Bernabéu y la Puerta de Europa. La delimitación del barrio es dada por el Paseo de la Castellana, una de las grandes arterias de Madrid que conectan con las autopistas M30 y M11. Grandes bancos y empresas están instalados aquí pero también modernas galerías de arte  y locales organizadores de eventos, especialmente a lo largo del Paseo de la Castellana y entre las estaciones de metro. Dado que esta zona es tan grande, también se ha convertido en un área residencial, lo cual nos permite encontrar muchos colegios y bloques residenciales.</p>
          <div style="margin-bottom: 40px; display: flex; justify-content:space-between; flex-wrap: wrap;">
          <img src="images/infotrl/chamartin1.png" height="200px" style="margin-right: 10px;"/>
          <img src="images/infotrl/chamartin2.png" height="200px" style="margin-right: 10px;"/>
          </div>
          <p><strong>Hortaleza</strong></p>
          <p>DESCRIPCIÓN: lo que hoy consideramos como el barrio de Hortaleza, originalmente era un pueblo pequeñito a lo alto de una colina, rodeado de ríos y abrevaderos. Este pueblo fue transformando sus viñedos y campos de cereal en granjas muy grandes y así tener la capacidad de producir productos locales para los nobles. A día de hoy, Hortaleza es uno de los cinco barrios con la población más joven de Madrid. Debido a la localización del prestigioso “Lycée Français”, se ha formado una gran comunidad francesa y componen la tercera población más extendida de la zona. Hay incluso una tienda que ofrece libros en francés, llamada “Frañol”. Sanchinarro, una comunidad independiente hasta 1950, ahora forma parte de Hortaleza. La zona ha vivido un gran crecimiento en urbanismo en los últimos años.</p>
          <div style="margin-bottom: 40px; display: flex; justify-content:space-between; flex-wrap: wrap;">
          <img src="images/infotrl/hortaleza1.png" height="200px" style="margin-right: 10px;"/>
          <img src="images/infotrl/hortaleza2.png" height="200px" style="margin-right: 10px;"/>
          <img src="images/infotrl/hortaleza3.png" height="200px" style="margin-right: 10px;"/>
          </div>
          <p><strong>La Latina</strong></p>
          <p>DESCRIPCIÓN: al sur de la Plaza Mayor encontramos La Latina, este precioso barrio compuesto por arquitectura latina y pequeñas callejuelas que nos maravillan con edificios del siglo XVIII. Aquí encontrarás las calles llenas de restaurantes con sus terrazas, bares tradicionales y tiendas de antigüedades. Los domingos por la mañana La Latina se convierte en el mercado conocido como “El Rastro” donde podemos encontrar puestos tradicionales pero también contemporáneos. La increíble bóveda de la Basílica de San Francisco El Grande proporciona el fondo escenario perfecto para las el barrio más popular para ir de tapeo con los amigos. Ecléctico y vibrante, este barrio es único para pasar tiempo dentro de él y explorar una de las partes más antiguas de Madrid.</p>
          <div style="margin-bottom: 40px; display: flex; justify-content:space-between; flex-wrap: wrap;">
          <img src="images/infotrl/latina1.png" height="200px" style="margin-right: 10px;"/>
          <img src="images/infotrl/latina2.png" height="200px" style="margin-right: 10px;"/>
          <img src="images/infotrl/latina3.png" height="200px" style="margin-right: 10px;"/>
          </div>
          <p><strong>Retiro</strong></p>
          <p>DESCRIPCIÓN: Retiro es el parque más grande y popular de Madrid y así se llama el barrio que situado al este del parque. Es perfecto para disfrutar de tranquilidad ya que el bullicio se queda al otro lado del parque. Dentro del Retiro puedes disfrutar de su lago, el Palacio de Cristal, el Jardín de Rosas y sus amplias zonas de césped. Hay muchas actividades como entrenamientos y clubs de running, o clases de patines y yoga. El barrio de Retiro se compone de seis distritos: Jerónimos, Ibiza, Estrella, Niño Jesús, Pacífico y Adelfas. Jerónimos es sin duda el más lujoso y representativo. 
          Jeronimos: una de las zonas del Retiro, cerca al parque y más específicamente delimitado por la calle Alcalá, la Avenida Menéndez Pelayo y los Paseos Prado y Reina Cristina. Este enclave está formado por edificios señoriales con casas espaciosas y lujosas que alardean de una gran demanda pese a tener los precios más altos de Madrid, incluso por encima de Salamanca.
          Esta zona disfruta de su proximidad al parque del Buen Retiro, el pulmón de Madrid y de su cercanía a monumentos históricos como la Puerta de Alcalá, el Palacio de Cibeles, el Museo del Prado y el Palacio de la Bolsa entre otros.
          </p>
          <div style="margin-bottom: 40px; display: flex; justify-content:space-between; flex-wrap: wrap;">
          <img src="images/infotrl/retiro1.png" height="200px" style="margin-right: 10px;"/>
          <img src="images/infotrl/retiro2.png" height="200px" style="margin-right: 10px;"/>
          <img src="images/infotrl/retiro3.png" height="200px" style="margin-right: 10px;"/>
          </div>
          <p><strong>Salamanca</strong></p>
          <p>DESCRIPCIÓN: Salamanca es el barrio más lujoso de Madrid. Se encuentra “encima” del Parque del Buen Retiro y al este del Paseo de la Castellana. Las dos grandes arterias de este barrio son la calle Velázquez y Serrano y sus dos principales estaciones de metro comparten el nombre. Es un barrio tranquilo de Madrid y al igual que los barrios lujosos de otras ciudades, es aquí donde encontramos las tiendas de grandes diseñadores de ropa y zapatos, los restaurantes de major calidad y las propiedades de más demanda. El barrio Salamanca consigue, sin embargo, equilibrar el estilo de vida de alto nivel con una vida de barrio y podemos encontrar bares y mercados tradicionales y acogedores.</p>
          <div style="margin-bottom: 40px; display: flex; justify-content:space-between; flex-wrap: wrap;">
          <img src="images/infotrl/salamanca1.png" height="200px" style="margin-right: 10px;"/>
          <img src="images/infotrl/salamanca2.png" height="200px" style="margin-right: 10px;"/>
          <img src="images/infotrl/salamanca3.png" height="200px" style="margin-right: 10px;"/>
          </div>
          <p><strong>Argüelles</strong></p>
          <p>DESCRIPCIÓN: Moncloa / Argüelles tiene todo lo que puedas necesitar, ¡a tan solo unos pasos del centro!
          Esta zona tiene una energía fantástica y está llena de tiendas, bares, supermercados y grandes restaurantes. A tiro de piedra está la Gran Vía, con todos los teatros y tiendas que deseas. Su gran comunicación con el resto de la ciudad hace que vivir en esta zona sea muy cómodo. Las líneas de metro 3 y 6 pasan por aquí, y la estación de Moncloa de autobuses te llevarán a donde necesites. Es también muy conveniente para salir de la ciudad en coche, ya que la autopista A-6 es muy accessible. 
          Este barrio es perfecto si te gusta:
          <ul>
          <li>– tener muchas tiendas y actividades cerca</li>
          <li>– correr o andar por tu barrio. Te encantará el parque de Moncloa y Plaza España, con su Templo de Debod (tercera foto)</li>
          <li>– vivir en un barrio bonito con muchas actividades pero que sea tranquilo por la noche.</li>
          </ul>
          </p>
          <div style="margin-bottom: 40px; display: flex; justify-content:space-between; flex-wrap: wrap;">
          <img src="images/infotrl/arguelles1.png" height="200px" style="margin-right: 10px;"/>
          <img src="images/infotrl/arguelles2.png" height="200px" style="margin-right: 10px;"/>
          </div>
          <p><strong>Justicia</strong></p>
          <p>DESCRIPCIÓN: Justicia es la zona más “pija” de Madrid junto con el barrio Salamanca. Aquí es donde viven los grandes diseñadores, políticos y altos cargos de grandes bancos y bufetes de abogados. Con un estilo que se podría considerer incluso parisino, esta zona está muy cerca de toda la actividad de Chueca y Malasaña.
          Todas las zonas de Madrid tienen su personalidad pero cada una tiene influencia de sus residents. Así, en Alonso Martínez podemos encontrar tiendas de diseño, zonas de encuentro de artistas, tiendas de chocholate y pastelerías de lujo, bares chill out y apartamentos únicos, ¡todo en unas cuantas calles!
          Recomendamos vivir en Justicia si quieres vivir en la zona más exclusiva y lujosa del centro de Madrid, donde la vida madrileña se mezcla con edificios parisinos.
          </p>
          <div style="margin-bottom: 40px; display: flex; justify-content:space-between; flex-wrap: wrap;">
          <img src="images/infotrl/justicia1.png" height="200px" style="margin-right: 10px;"/>
          <img src="images/infotrl/justicia2.png" height="200px" style="margin-right: 10px;"/>
          <img src="images/infotrl/justicia3.png" height="200px" style="margin-right: 10px;"/>
          </div>
          <p><strong>Palacio</strong></p>
          <p>DESCRIPCIÓN: Palacio es el centro histórico de Madrid donde encontramos los más antiguos y maravillosos edicios de la capital. El Palacio Real (que da, en parte, nombre a la zona) está rodeado de preciosos jardines y cafés tradicionales con terraces en las cuales podremos disfrutar del sol. El Teatro Real está a escasos minutos y ofrece todo el año un programa de gran calidad. Esta zona es mucho más tranquila que Malasaña y Chueca pero sigue estando muy cerca de lo que ofrecen. Debido a los altos precios de la zona (causados por la proximidad al Palacio Real), no viven muchos estudiantes o jóvenes aquí.</p>
          <div style="margin-bottom: 40px; display: flex; justify-content:space-between; flex-wrap: wrap;">
          <img src="images/infotrl/palacio1.png" height="200px" style="margin-right: 10px;"/>
          <img src="images/infotrl/palacio2.png" height="200px" style="margin-right: 10px;"/>
          <img src="images/infotrl/palacio3.png" height="200px" style="margin-right: 10px;"/>
          </div>
          <p><strong>Pozuelo de Alarcón</strong></p>
          <p>DESCRIPCIÓN: área muy accessible y cómoda con grandes calidades, ¡a tan solo 15-20 minutos de Madrid!
          La diferencia de Pozuelo de Alarcón con otras zonas de las afueras de Madrid, es su buena comunicación con la ciudad. Dos líneas de Metro Ligero, una línea de Cercanías y media docena de autobuses conectan Pozuelo con Madrid a diario. Puedes estar en el centro de Madrid en 30 minutos. En coche, con tan solo 25 minutos de trayecto puedes estar en cualquier zona de la ciudad.
          </p>
          <div style="margin-bottom: 40px; display: flex; justify-content:space-between; flex-wrap: wrap;">
          <img src="images/infotrl/pozueloalarcon1.png" height="200px" style="margin-right: 10px;"/>
          <img src="images/infotrl/pozueloalarcon2.png" height="200px" style="margin-right: 10px;"/>
          </div>
          <p><strong>La Moraleja</strong></p>
          <p>DESCRIPCIÓN: nos encontramos cerca del aeropuerto Adolfo Suárez Madrid Barajas, rodeados de la A1, la R2 y la M40. Perteneciente a la municipalidad de Alcobendas, La Moraleja tiene 3 subdivisiones: El Soto, La Moraleja, & El Encinar de los Reyes. 
          <ul>
          <li>•	El Soto: cerca del metro, colegios y zonas comerciales, se encuentra al norte de La Moraleja. El Soto ofrece sobre todo apartamentos y adosados, la mayoría en urbanizaciones cerradas.</li> 
          <li>•	La Moraleja es lo más exclusivo. Dependiendo de dónde se encuentre la casa, podemos ver Alcobendas o Madrid. Está formado por parcelas más grandes, la mayoría con chalets independientes.</li>
          <li>•	El Encinar está al sur. Es único porque anteriormente era donde se encontraba la base military estadounidense y como consecuencia las viviendas tienen el estilo del país. Es la zona más alejada del metro y aunque haya un autobús que pasa por toda la zona, no es muy fiable y es poco utilizado por los vecinos.</li>
          </ul>
          Algunas de las mejores escuelas se encuentran en La Moraleja, como el International College Spain (ICS), Kings College, y el St. George’s; rodeados de zonas verdes, parques y clubs de deporte. 
          La Moraleja tiene su propia seguridad y la mayoría de las viviendas se encuentran en urbanizaciones cerradas. 
          </p>
          <div style="margin-bottom: 40px; display: flex; justify-content:space-between; flex-wrap: wrap;">
          <img src="images/infotrl/moraleja.png" height="200px" style="margin-right: 10px;"/>
          </div>
          <p><strong>Boadilla del Monte</strong></p>
          <p>DESCRIPCIÓN: Boadilla del Monte es una de las municipalidades más selectas de la Comunidad de Madrid. Se encuentra a tan solo 14 kilómetros del centro de la ciudad y es la zona ideal para los que quieren escapar del bullicio. Es una pequeña ciudad tranquila, con buen ambiente y buena comunicación con la capital.
          Está en el medio de una zona verde que ofrece excelentes vistas. De hecho, lo rodean 750 hectáreas de bosque, lo cual proporciona aire limpio. Debido a la larga historia de esta pequeña ciudad podemos encontrar sitios de interés cultural y arquitectónico como el Palacio del Infante Don Luis y la Fuente de Ventura Rodríguez.
          En Boadilla del Monte hay una gran variedad de propiedades, desde apartamentos hasta adosados y chalets independientes. Lo que todos tienen en común es lujo. Los residentes pueden disfrutar de jardines, piscinas, terrazas y muchos otros elementos básicos para crear un entorno de relax. Además, como lo demuestran las últimas estadísticas, comprar en esta ciudad es una gran inversión ya que no se vio afectada por la crisis económica y las viviendas siguen aumentando su valor.

          No olvidemos que esta ciudad tiene escuelas de gran prestigio a nivel nacional. Hay diversos colegios y academias de idiomas como la Escuela Oficial de Idiomas o un campus de la Universidad de San Pablo. También tiene varios centros médicos, tanto privados como públicos.
          </p>
          <div style="margin-bottom: 40px; display: flex; justify-content:space-between; flex-wrap: wrap;">
          <img src="images/infotrl/boadilla.png" height="200px" style="margin-right: 10px;"/>
          </div>
          <h3 class="subtitulo">MOVERSE POR MADRID</h3><p>Acostumbrase a conducir en Madrid puede llevarte algunas semanas, pero intenta recordar que Madrid tiene tres grandes autopistas que rodean la ciudad: la M-30, la M-40 y la M-50. Si tienes  que cruzar la ciudad cualquiera de estas opciones es buena si no te sientes cómodo atravesando la ciudad. Ten en cuenta también que hay muchos radares (fijos y móviles).</p>

          <h3 class="subtitulo">PARKING</h3><p> Aparcar en la ciudad es extremadamente complicado. Recomendamos que dejes el coche en los parkings públicos del centro o bien utilizar la zona de aparcamiento “azul o verde” de la calle con el sistema de parquímetro. En la zona azul se puede aparcar hasta 4 horas y en la zona verde hasta 2 horas. Si aparcas en un sitio prohibido y el coche se lo ha llevado la grúa, puedes llamar al 914 068 810 o meter tu matrícula en este <a href="https://www.emtmadrid.es/EMTGruas/LocalizaVehiculo" target="_blank">enlace</a> para saber dónde se han llevado tu coche. La multa será de aproximadamente 180€ para recuperarlo.</p>

          <h3 class="subtitulo">TRANSPORTE PÚBLICO</h3><p> Se necesita una tarjeta magnética para entrar y salir del sistema de transporte público en Madrid. Esta tarjeta puede adquirirse y ser recargada en cualquier estación de metro y tren. También puedes adquirir un abono mensual que le permite usar el transporte público sin límite de veces. Funciona por zonas y para el cercanías, metro y autobuses. Este abono se puede solicitar <a href="https://tarjetatransportepublico.crtm.es/CRTM-ABONOS/entrada.aspx" target="_blank"></a> online. El sistema de transporte público en Madrid incluye <a href="https://www.metromadrid.es/es" target="_blank">metro</a>, <a href="https://www.metromadrid.es/es" target="_blank">autobús</a>, <a href="https://www.metromadrid.es/es" target="_blank">cercanías</a> y <a href="https://www.metromadrid.es/es" target="_blank">metro ligero</a>.</p>

          <h3 class="subtitulo">TAXI Y SERVICIOS PRIVADOS</h3><p> Hay más de 15.000 taxis en Madrid, solo hay que levantar la mano para pedir uno. También se puede pedir vía app: Free Now, TXMAD. También están disponibles servicios privados como Uber y Cabify.</p>

          <h3 class="subtitulo">COCHE ELÉCTRICO</h3><p> Los coches eléctricos se han vuelto muy populares en la ciudad. Se paga por los minutos consumidos. El único límite es tener carné de conducir y aparcar en la zona delimitada. Algunas empresas: <a href="https://www.share-now.com/" target="_blank">ShareNow</a>, <a href="https://zity.eco" target="_blank">Zity</a>, <a href="https://www.emov.eco/" target="_blank">Emov</a>, <a href="https://www.wible.es/" target="_blank">Wible</a>. Los precios varían, así que no dudes en investigar</p>
          <img src="images/infotrl/certificados.png" width="100%" style="margin:0 auto; display: block"/>
          `,
            espana: `
            <h3 class="titulo">Bienvenidos a España</h3>
            <blockquote>¡Felicidades por elegir España como destino! Es considerado como uno de los mejores países en calidad
                de vida, así que has hecho una gran elección. Desde Steps Relocation trabajaremos para hacer el
                traslado más fácil.<br>
                Nuestro equipo está compuesto de expatriados también, así que empatizamos totalmente contigo<br>
                Deseando conocerte pronto,<br><br>
                Lydia Martínez - CEO</blockquote>
                <img src="images/infotrl/espana_intro1_es.jpg" width="100%" /><br/>
                <img src="images/infotrl/espana_intro2_es.jpg" width="100%" /><br/>
            <p>España es un país miembro de la Unión Europea, y cuya forma de gobierno es la Monarquía
                Parlamentaria. Su territorio, con capital en Madrid, está organizado en diecisiete comunidades
                autónomas, formadas a su vez por cincuenta provincias; y dos ciudades autónomas.<br>
                Tiene una extensión de 505 370 km², por lo que es el cuarto país más extenso del continente. Con una
                altitud media de 650 metros sobre el nivel del mar es uno de los países más montañosos de Europa. Su
                población supera los 48 millones de habitantes.<br>
                El producto interior bruto coloca a la economía española entre las 15 primeras del Mundo. España es
                una potencia turística y además, el octavo país del mundo con mayor presencia de multinacionales.
            </p>
            <p>España tiene un clima muy diverso a lo largo de todo su territorio. Predomina el carácter
                mediterráneo en casi toda su geografía. En el norte y noreste suele ser un clima nuboso con lluvias
                ocasionales.<br>
                España tiene un índice de criminalidad muy bajo, sin embargo, como en cualquier otro país, hay que
                poner atención, especialmente en sitios turísticos</p>
            <h3 class="subtitulo">COMIDA, VINO Y HORARIO</h3>
            <p>Los españoles tienen fama de disfrutar mucho de la vida: los platos locales y los vinos son la mejor
                forma de hacerlo. El pescado y el marisco son excelentes por su frescura, y el excelente aceite de
                oliva, se usa a diario en la cocina.<br>
                ¡Cuidado con los horarios! Los españoles comen mucho más tarde que sus vecinos europeos. La mayoría
                de los restaurantes han flexibilizado su horario, pero hay muchos cuya apertura no se produce antes
                de las 9 de la noche. Si no deseas una cena copiosa, siempre puedes ir a uno de los muy comunes
                bares de tapas, que sirven comida todo el día.</p>
            <h3 class="subtitulo">VINOS</h3>
            <p>
                Una de las mejores cosas de ser un expatriado en España es el descubrimiento de sus vinos. Para
                entenderlos mejor:<br>
                <b>Crianza</b>: vino que se deja envejecer 6 meses en barricas y dos años en botella.<br>
                <b>Reserva</b> el vino se deja envejecer un mínimo de 12 meses en barrica de roble y 3 años en
                botella.<br>
                <b>Gran Reserva</b> debe envejecer más de dos años en barrica de roble y luego 5 años en
                botella.<br>
                En España los vinos se “dividen” por <b>Denominaciones de Origen (DO)</b>. Constituye el sistema
                utilizado en nuestro país para el reconocimiento de una calidad diferenciada, consecuencia de
                características propias y diferenciales debidas al medio geográfico en el que se producen las
                materias primas, se elaboran los productos y a la influencia del factor humano que participa en las
                mismas.<br>
                Hay 70 Denominaciones de Origen en España y te invitamos a descubrirlas todas, pero las más
                importantes y una buena manera de empezar son <b>Rioja, Ribera del Duero, Valdepeñas y Navarra en
                    tintos y Rias Baixas, Rueda y Ribeiro en blancos</b>.<br>
            </p>
            <h3 class="subtitulo">CÓMO PREPARAR A LA FAMILIA PARA EL CAMBIO</h3>
            <p>
                Preparar a la familia para un traslado es esencial, te dejamos algunos consejos:<br>
                • <b>Leer</b> tanto como sea posible acerca de España, la cultura, la historia... hay un montón de
                información en internet.<br>
                • <b>Animar</b> a los niños a <b>descubrir</b> todo lo que puedan acerca de su nuevo destino. Hay
                que contarles que aquí encontrarán muchos parques de diversiones y parques acuáticos, los viajes que
                harán a la costa o a esquiar... si se les incluye en los planes, aceptarán mejor el cambio.<br>
                • Según vaya acercándose el momento de venir a vivir, recuerda que España es un país maravilloso
                para que tus amigos y familiares te visiten. Decid a todo el mundo que vengan a veros... ¡pero tened
                en cuenta que lo harán! <br>
                • Es importante para vosotros y especialmente para los niños, <b>mantener los lazos</b> con los amigos que
                dejasteis atrás. Animadlos a que mantengan el contacto. <br>
                Recuerda que esto es un proyecto de familia. Este traslado es un nuevo trabajo para el “responsable”
                del traslado, pero es una aventura para todos. Venid con la mentalidad de disfrutarlo.<br>
                Os daremos todo el apoyo imaginable para que os sintáis <b>positivos, felices y acompañados</b>.</p>
            <h3 class="subtitulo">ASUNTOS MÉDICOS</h3>
            <p>
                La medicina pública (Seguridad social) es <b>excelente</b> en España y cuenta con los mejores médicos y
                equipos.<br>
                Hay posibilidad de contratar sanidad privada y no es algo excesivamente caro. En el mercado hay
                bastantes opciones. Pregunta primero en la empresa donde te han contratado si ofrecen ese beneficio
                para los empleados antes de comenzar la búsqueda.</p>
            <h3 class="subtitulo">EDUCACIÓN</h3>
            <p>
                Existen tres tipos de colegios:<br>
                LOS PRIVADOS. Tienes dos tipos <br>
                1) Nacionales, que siguen el sistema educativo español, y que suelen tener varias horas semanales
                dedicadas al inglés y a partir de 1º de ESO un segundo idioma. <br>
                2) Internacionales, en los que se sigue el sistema educativo diferente al español. Hay Currículums
                Británicos, americanos, IB, francés, alemán, italiano.<br>
                LOS CONCERTADOS. Reciben una ayuda económica del gobierno y están obligados a aceptar una serie de
                normas dictadas por el Ministerio de Educación, etc. pero son más económicos que los privados. Para
                acceder a ellos existe un sistema de puntos, que se otorgan por cercanía al domicilio o trabajo, si
                tienen hermanos en el centro, entre otros, y es necesario estar empadronado.<br>
                LOS PÚBLICOS. La enseñanza es gratuita a excepción de las tasas de escolarización. Se rigen por las
                normas del Ministerio. Lo que puede pasar, es que no asignen el colegio preferido por la familia.
                Pero tienen obligación de no dejar ningún niño sin escolarizar.</p>
            <h3 class="subtitulo">AYUDA DOMÉSTICA</h3>
            <p>
                Para encontrar ayuda doméstica se puede usar una agencia, que garantiza sus servicios durante varios
                meses (si no encaja bien la persona que te han encontrado, puedes solicitar un cambio). <br>
                INTERNA. Una persona interna vive en la casa. Esperará tener su propia habitación. Se hará cargo de
                la limpieza, cocina y niños según lo negociado en la entrevista. Hay un salario mínimo regulado por
                El Gobierno y están sujetas a Seguridad Social que hay que pagar aparte. La jornada laboral no debe
                superar las 40 horas semanales.<br>
                EXTERNA. Mismas obligaciones que la persona interna, pero no vive en casa. El salario se calcula en
                base al salario mínimo interprofesional, dependiendo de las horas contratadas.<br>
                UNA ASISTENTA. Trabajará sólo algunas horas al día y se le paga entre 10 y 12 euros por hora.
                Igualmente, hay obligación de registrar las horas trabajadas para el alta en la Seguridad Social.
                <br>
                SERVICIOS DE CANGURO. Lo mejor es pedírselo a una vecina joven o alguien conocido y pagar unos 10
                euros la hora. Negocia tarifas para noches largas.<br>
                <br>
            </p>
            <img src="images/infotrl/certificados.png" width="100%" style="margin:0 auto; display: block"/>
            `
        },
        modalcreartarea: {
            notes: "Notas",
            notifyTRL: 'Notificar por email al TRL',
            showTRL: "Mostrar en la agenda del TRL",
            dateTime: 'Fecha y hora',
            task: "Tarea",
            noResults: "No hay resultados",
            newTask: "Nueva tarea",
            editTask: "Editar tarea",
            taskDeleted: "La tarea se ha eliminado correctamente",
            taskCreated: "La tarea se ha creado correctamente",
            taskEdited: "La tarea se ha editado correctamente",
            removeTask: "Eliminar tarea"
        },
        modalcrearservicio: {
            hint: "Selecciona una de la lista o crea una nueva escribiendo un nombre",
            removed: "se ha eliminado correctamente.",
            the: "El ",
            your: "Tu",
            has: "se ha",
            successfully: "satisfactoriamente",
            special: "El servicio de suministros es especial. No se puede eliminar ni se pueden modificar sus tareas ni variantes",
            special2: "El servicio de cierre es especial. No se puede eliminar ya que tiene campos extras.",
            special3: "Este servicio es especial. No se puede eliminar ya que afecta al funcionamiento de algún campo de información del TRL.",
            startEnd: "Fecha inicio/fin",
            hint2: "Importante: si eliges 'No' el servicio no aparecerá en la ficha del usuario, solo la verá el TRL a modo informativo. Ej.- Paquete bienvenida",
            hint3: "Selecciona el servicio precedente. El nuevo servicio será colocado detrás del elegido en esta lista.",
            variant: "Variantes de servicio",
            max: "Podrá tener un máximo de 4.",
            max2: "Ej.- Compra vivienda Normal | Premium (rellenar solo si tiene variantes dentro del mismo servicio)",
            tasks: "Tareas",
            optionNameEn: "Nombre opción EN",
            optionNameEs: "Nombre opción ES",
            taskNameEs: "Nombre tarea ES",
            taskNameEn: "Nombre tarea EN",
            sort: "Orden",
            hintSel: "Selecciona el paquete precedente. El nuevo paquete será colocado detrás del elegido en esta lista.",
            createdMax: "Están creados el máximo número de variantes, elimina alguno si quieres añadir otro."
        },
        modalcrearusuario: {
            email: "Email",
            lastname: "Apellidos",
            name: "Nombre",
            photo: "Foto",
            phone: "Teléfono",
            lang: "Idiomas",
            companies: "Compañías",
            professionalEmail: "Email profesional",
            noResults: "No hay resultados",
            company: "Compañía"
        },
        modalcrearvivienda: {
            wait: "Se están optimizando las imágenes, el proceso puede tardar. Por favor espere sin cerrar la ventana",
            waitCompress: "Espera unos segundos hasta que se acaben de comprimir las imágenes",
            notes: "Notas",
            email: "Email",
            phone: "Teléfono",
            owner: "Propietario",
            propertyData: "Datos de la propiedad",
            english: "Inglés",
            spanish: "Español",
            description: "Descripcción",
            included: "Incluído en el presupuesto",
            vehiclesNumber: "Nº vehículos",
            haveGarage: "Tiene garaje",
            garage: "Garaje",
            ac: "AC",
            heat: "Calefacción",
            garden: "Jardín",
            terrace: "Terraza",
            pool: "Piscina",
            traster: "Trastero",
            childZone: "Zonas infantiles",
            serviceRoom: "Habitación de servicio",
            sunny: "Soleado",
            near: "Cerca del metro/FGC",
            pets: "Admite mascotas",
            characteristics: 'Características',
            rentCond: "Condiciones de alquiler",
            available: "Disponible",
            noResults: "No hay resultados",
            contractType: "Tipo de contrato",
            select: "Seleccionar",
            communitySpends: "Gastos de comunidad",
            style: "Estilo",
            stateR: "Estado*",
            equipmentR: "Equipamiento*",
            price: "Precio",
            bathNumber: "Nº baños",
            roomsNumber: "Nº habitaciones",
            level: "Planta / nº piso",
            area: "Superficie m2",
            zoneR: "Zona / barrio*",
            address: "Dirección",
            general: "General",
            images: "Imágenes",
            mainImage: "Imagen principal",
            photos: "Fotos",
            newHome: "Nueva vivienda",
            editHome: "Editar vivienda",
            houseType: 'Tipo de vivienda',
        },
        modalenviarviviendas: {
            send: "Enviar",
            addNote: "Añadir nota",
            link: "Enlace",
            externalLinks: "Links externos",
            showAll: "Mostrar todas",
            selected: "Seleccionadas",
            sendHomes: "Enviar viviendas",
            homeSent: "Las viviendas se han enviado correctamente.",
            noteP: "Nota: "
        },
        modalsimple: {
            cambiarcontrasena: 'Cambiar contraseña',
            tucontrasenase: 'Tu contaseña se ha modificado correctamente.',
            contrasenaactual: 'Contraseña actual',
            nuevacontrasena: 'Nueva contraseña',
            repitelanueva: 'Repite la nueva contraseña',
            porlomenos4: 'Por lo menos 4 caracteres',
            cancelar: 'Cancelar',
            cambiar: 'Cambiar',
            copy: "Copia el siguiente texto para incluir el link de acceso del TRL en el email de bienvenida.",
            removeHouse: "Eliminar vivienda",
            sureRemove: "¿Seguro que quieres eliminar esta vivienda?",
            close: "Cerrar",
            yes: "Si",
            no: "No",
            removeUser: "Eliminar usuario",
            sureRemoveUser: "¿Seguro que quieres eliminar el usuario",
            sureRemoveGeneral: "¿Seguro que quieres eliminar ",
            service: "servicio",
            company: "compañía",
            remove: "Eliminar",
            package: "Paquete",
            removeFile: "Eliminar archivo",
            error: "Ha ocurrido un error de servidor",
            refreshPage: "Por favor refresca la página",
            refresh: "Refrescar",
            hint2: "Cuando se reactiva un TRL ya no se finalizará automáticamente al terminar todos sus servicios.",
            hint3: " Sólo se podrá cerrar manualmente desde el botón 'Otras acciones'",
            sureReactivate: "¿Seguro que quieres reactivar el usuario",
            sureClose: "¿Seguro que quieres cerrar el usuario",
            canActivate: "Podrás reactivarlo en cualquier momento desde el botón \"Otras acciones\"",
            ok: "De acuerdo",
            sendForm: "Enviar formulario de satisfacción.",
            complete: "Se han completado todos los servicios",
            ofTRL: "del TRL",
            closeTRL: "Cerrar TRL",
            reactivateTRL: "Reactivar TRL",
            trlFinished: "¡TRL finalizado!",
            accepted: "Aceptado",
            rejected: "Rechazado",
            has: "Has",
            beingCounselor: "ser consejera de",
            reanud: "reanudar",
            cancel: "cancelar",
            willRemove: "Se eliminarán todas las tareas asociadas a el servicio.",
            theService: "el servicio",
            reanudService: "Reanudar servicio",
            cancelService: "Cancelar servicio",
            sureWant: "¿Seguro que quieres",
            sureRemoveFile: "¿Seguro que quieres eliminar el archivo"
        },
        tfauth: {
            badCode: 'Código erróneo',
            accept: 'Aceptar',
            code: 'Código',
            codePlaceholder: "Enter Google's code"
        }
    }
}


export default es;
